export function formatType(value,dropdownList) {
    for (let i = 0; i < dropdownList.length; i++) {
        if (dropdownList[i].dict_value == value) {
            return dropdownList[i].dict_label
        }
    }
}

export function formatTime(value) {
    if (!value) return ''
    let date = new Date(value * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-';
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
}

export function getDownloadAddress(path, name) {
    let uri = path.split('/')
    return `${config_env.BASE_URL}/api/file/common/download?fileUri=${uri.pop()}&rename=tipdm-race-web`;
}